export default __webpack_public_path__ + "static/media/house1large.c2f2a6f5.png";